import { render, staticRenderFns } from "./child.vue?vue&type=template&id=5a559677"
import script from "./child.vue?vue&type=script&lang=js"
export * from "./child.vue?vue&type=script&lang=js"
import style0 from "./child.vue?vue&type=style&index=0&id=5a559677&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports